(function($, DIC){
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';
	const slideSpeed = '400';
	const lang = location.pathname.split('/')[1];

	const newsTopRedirect = () => {
		const newsArea = $('.js-news-top');
		let mpoketLang;
		if(lang === 'ja') {
			mpoketLang = 'all';
		} else {
			mpoketLang = 'enall';
		}
		if(!(lang === 'cn')) {
			// マジカルポケット、すべてのニュース
			const getJSONmpocket = () => {
				return $.ajax({
					type: 'GET',
					url: `https://xml.irpocket.com/4631/JS/release-${mpoketLang}-all.js`,
					dataType: 'jsonp',
					jsonp: 'callback',
					jsonpCallback: 'ir20handler'
				});
			};
			if(location.pathname === '/'+lang+'/news/' || location.pathname === '/'+lang+'/news/index.html') {
				getJSONmpocket().done(function (mpocket) {
					let mpocketListdate = new Date(mpocket.item[0].published);
					let mpocketListyear = mpocketListdate.getFullYear();
					var latestYear_length = $('.js-news-year').find('.rt_latest_year').length;
					if(latestYear_length === 0) {
						var vD = new Date();
						var vYear = vD.getYear();
						var vYear4 = (vYear < 2000) ? vYear+1900 : vYear;
						location.href = '/'+lang+'/news/' + vYear4 + '/';
					} else {
						var latestYear;
						var cmsYear = $('.js-news-year').find('.rt_latest_year').eq(0).text();

						if(mpocketListyear > cmsYear) {
							latestYear = mpocketListyear;
						} else {
							latestYear = cmsYear;
						}
						location.href = '/'+lang+'/news/' + latestYear + '/';
					}
				});
			} else {
				newsArea.addClass(a);
			}
		} else {
			if(location.pathname === '/'+lang+'/news/' || location.pathname === '/'+lang+'/news/index.html') {
				var latestYear_length = $('.js-news-year').find('.rt_latest_year').length;
				if(latestYear_length === 0) {
					var vD = new Date();
					var vYear = vD.getYear();
					var vYear4 = (vYear < 2000) ? vYear+1900 : vYear;
					location.href = '/'+lang+'/news/' + vYear4 + '/';
				} else {
					var latestYear = $('.js-news-year').find('.rt_latest_year');
					location.href = '/'+lang+'/news/' + latestYear[0].textContent + '/';
				}
			} else {
				newsArea.addClass(a);
			}
		}
	};

	const newsYearList = () => {
		if($('.js-news-yearList').length) {
			let latestYear = $('.js-header-newsYearList').find('.rt_latest_year').text();
			let earliestYear = 2015;
			const directoryYear = location.pathname.split('/')[3];
			if(lang === 'cn') {
				earliestYear = 2018;
			}

			// optionを追加
			for(var i =latestYear; i>=earliestYear; i--) {
				$('.js-news-yearList').append($('<option>').html(''+i+'').val(''+i+''));
			}
			// 見ている年をselected
			$('.js-news-yearList').val(directoryYear);

			// 選択した年に飛ばす
			$('.js-news-yearList').change(function(){
				location.href = location.pathname.replace(directoryYear, $(this).val());
			});
		}
	};

	const newsCurrent = () => {
		if($('.news-tab').length) {
			$('.news-tab li a').parent('li').removeClass(a);

			for(var i=0; i<$('.news-tab li a').length; i++) {
				if(location.pathname === $('.news-tab li a').eq(i).attr('href')) {
					$('.news-tab li a').eq(i).parent('li').addClass(a);
				}
			}
			$('.news-head .news-head-category').html($('.news-tab li.is-active').text());
		}
	};

	newsTopRedirect();
	newsYearList();
	newsCurrent();

})(window.jQuery, window.DIC);